import { IconClockExclamation, IconHomeCheck } from '@tabler/icons-react'
import { LoadingIcon, DroppingIcon, DrivingIcon } from '../../TripGrid/TripGridCell/TripStatus'
import type { RouteItem } from '../types'
import { Horizontal } from '@gravitate-js/excalibrr'
import { ICON_SIZES } from './DriverMap/constants'
import '../styles.css'

type DriverStatusIconProps = {
  action: RouteItem['action'] | null | undefined
  isCompleted?: boolean
  size?: keyof typeof ICON_SIZES
}

export function DriverStatusIcon({ action, isCompleted = false, size = 'large' }: DriverStatusIconProps) {
  const { icon, color } = getDriverIcon({ action, isCompleted, size })

  return (
    <Horizontal
      className='driver-status-icon-container'
      style={{
        height: ICON_SIZES[size].container,
        width: ICON_SIZES[size].container,
        border: `2px solid ${color}`,
      }}
    >
      {icon}
    </Horizontal>
  )
}

function getDriverIcon({ action, isCompleted, size = 'large' }: DriverStatusIconProps) {
  let color = 'var(--theme-color-1)'
  let icon

  if (!action) {
    color = 'var(--gray-600)'
    icon = <IconClockExclamation size={ICON_SIZES[size].icon} color={color} />
  } else if (action === 'loading') {
    color = 'var(--theme-color-2)'
    icon = <LoadingIcon color={color} size={ICON_SIZES[size].icon} />
  } else if (action === 'dropping') {
    color = 'var(--theme-color-3)'
    icon = <DroppingIcon color={color} size={ICON_SIZES[size].icon} />
  } else if (action === 'driving to load') {
    color = 'var(--theme-color-2)'
    icon = <DrivingIcon color={color} size={ICON_SIZES[size].icon} />
  } else if (action === 'driving to drop') {
    color = 'var(--theme-color-3)'
    icon = <DrivingIcon color={color} size={ICON_SIZES[size].icon} />
  } else if (action === 'heading home' && isCompleted) {
    color = 'var(--theme-success)'
    icon = <IconHomeCheck color={color} size={ICON_SIZES[size].icon} />
  } else {
    icon = <DrivingIcon color={color} size={ICON_SIZES[size].icon} />
  }

  return { icon, color }
}
